// UserMovements.jsx
import React, { useEffect, useState } from 'react';
import { getDetailedUserInventories } from '../../services/inventoryServices';
import TopBarLogo from '../Shared/TopBarLogo';
import InventarioMovements from '../LoggedIn/InventarioMovements';
import '../../styles/Dashboard.css';

export default function UserMovements() {
  const [inventarios, setInventarios] = useState([]);
  const [error, setError] = useState(null);
  const [selectedInvId, setSelectedInvId] = useState(null);

  useEffect(() => {
    const fetchInventarios = async () => {
      try {
        const data = await getDetailedUserInventories();
        const creados = data.filter(inv => inv.FCRole === 'Creador');
        if (!creados.length) {
          setError('No tienes inventarios donde seas creador.');
        } else {
          setInventarios(creados);
        }
      } catch (err) {
        console.error('Error al obtener inventarios:', err);
        setError('Ocurrió un error al cargar los inventarios.');
      }
    };
    fetchInventarios();
  }, []);

  const handleSelect = e => {
    const id = e.target.value || null;
    setSelectedInvId(id);
  };

  return (
    <div>
      <div className="info-box">
        <h2 className="card-title">📦 Historial de Movimientos de Inventario</h2>
        {error ? (
          <p className="mensaje-aviso">{error}</p>
        ) : (
          <>
            <label htmlFor="inv-select">Selecciona inventario:</label>
            <select
              id="inv-select"
              value={selectedInvId || ''}
              onChange={handleSelect}
              className="input-filtro"
            >
              <option value="">-- Elige un inventario --</option>
              {inventarios.map(inv => (
                <option key={inv.FIInventario} value={inv.FIInventario}>
                  {inv.FCNombreInventario}
                </option>
              ))}
            </select>

            {selectedInvId && (
              <InventarioMovements FIInventario={selectedInvId} />
            )}
          </>
        )}
      </div>
    </div>
  );
}
